export enum DistanceUnitEnum {
  Kilometers = 'km',
  Meters = 'm',
  Miles = 'mi',
  Feet = 'ft',
}
